import React from "react";
import MainHome from "../../components/UserComponents/home/MainHome";
import LabSections from "../../components/UserComponents/home/LabSections";
import AboutUs from "../../components/UserComponents/home/AboutUs";
import Services from "../../components/UserComponents/home/Services";
import Commitment from "../../components/UserComponents/home/Commitment";
import Details from "../../components/UserComponents/home/Details";
import Book from "../../components/UserComponents/home/Book";
import Work from "../../components/UserComponents/home/Work";
import Testimonials from "../../components/UserComponents/home/Testimonials";
import TrustedPartners from "../../components/UserComponents/home/TrustedPartners";
import Stories from "../../components/UserComponents/home/Stories";
import OurCenters from './../../components/UserComponents/home/OurCenters';

const Home = () => (
  <div className="overflow-hidden bg-[#fafafa]">
    <MainHome />
    <LabSections />
    <AboutUs />
    <Services />
    <Commitment />
    <OurCenters />
    {/* <Details /> */}
    <Book />
    {/* <Work /> */}
    {/* <Testimonials /> */}
    <TrustedPartners />
    <Stories />
  </div>
);

export default Home;
